export default __webpack_public_path__ + "static/media/diamond.e7906b7e.svg";